import { getClient }  from '@locuslabs/people-insights-dashboard-api-sdk'
import * as Request       from '../request'
import * as Config        from '../config'


const insightsClient = async (stage = Config.getStage()) => {
    const accessToken = await Config.getAccessToken()
    return getClient({ token: accessToken, stage })
}

const generateEmbeddableDashboards = async () => {
    const client = await insightsClient()
    const credentials = await client.generateEmbeddableDashboards();

    return Request.axiosData(credentials)
}

const Insights = { generateEmbeddableDashboards }

export { Insights }
